import {
  httpGet
} from '@/api'
let prefix = '/give/pc/'
export const getGiftDetails = (params) => httpGet(prefix + 'gainGoodsInfo', params) // 详情